/* EcoFilter Ireland - water test finder (Oct 2026). Data comes from #wt-data (Shopify products in the water-testing collection).
   Deep links: /pages/water-testing?supply=well&grant=yes&county=Meath#finder */
(function () {
  var dataEl = document.getElementById('wt-data');
  var out = document.getElementById('wt-out');
  if (!dataEl || !out) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var P = D.products || {};
  var GRANT = D.grant || [];
  var root = out.closest('.wt');
  var state = { supply: '', grant: '', county: '', concerns: [] };
  var current = null; // {main:{...}, extras:[{...,on}]}

  var TICK = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2 8.5 6 12.5 14 3.5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function euro(c) {
    var v = c / 100, s = v % 1 === 0 ? String(v) : v.toFixed(2);
    var parts = s.split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '€' + parts.join('.');
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function has(k) { return state.concerns.indexOf(k) > -1; }

  var WHY = {
    check: 'Covers bacteria, iron, manganese, hardness and pH. The all-round check for a house on mains water.',
    plus_well: 'Adds nitrate, lead and copper to the Check suite, and covers everything we need to specify treatment for a well: iron, manganese, hardness, pH, nitrate and bacteria.',
    plus_group: 'Group schemes can carry nitrate and bacteria, so Check Plus, with nitrate, lead and copper, is the safer pick.',
    plus_lead: 'Adds lead and copper to the Check suite, so you\'ll know whether old pipes are a problem. Nitrate comes with it too.',
    bacteria: 'A bacteria-only test: E. coli, coliforms, enterococci and a total count. Quicker to read and lower cost than a full suite.',
    pfas: 'Measures 25 PFAS compounds plus the PFAS total the 2023 drinking water regulations set a limit for.',
    thm: 'Measures trihalomethanes, the by-products of chlorinating mains and group scheme water.',
    pesticides: 'Glyphosate, MCPA, 2,4-D, mecoprop and clopyralid, the weedkillers most likely to turn up near sprayed land.',
    langelier: 'Shows whether your water is eating into copper pipe and fittings or laying down scale.',
    legionella: 'One sample per kit. Testing several outlets? Choose the number on the product page.',
    bordbia: 'The five tests on the Bord Bia water standard: ammonia, nitrate, nitrite, E. coli and enterococci.',
    audit: 'The full 2023 regulations list in one go, over 80 parameters, including pesticides, THMs and metals.'
  };
  var EXTRA_NOTE = {
    pesticides: 'Glyphosate, MCPA and 3 more', pfas: '25 forever chemicals', thm: 'Chlorination by-products',
    langelier: 'Pipe corrosion or scale', legionella: 'One sample', bordbia: 'Farm assurance standard',
    bacteria: 'Bacteria only', check: '14 tests, the all-round check', plus: '18 tests incl. nitrate and lead'
  };
  var CONCERN_KEY = { bacteria: 'bacteria', pesticides: 'pesticides', corrosion: 'langelier', thm: 'thm', pfas: 'pfas', legionella: 'legionella', bordbia: 'bordbia' };

  function show(sel, on) {
    root.querySelectorAll('[data-wt-show="' + sel + '"]').forEach(function (el) { el.hidden = !on; });
  }

  function pick() {
    if (!state.supply) return null;
    if (state.supply === 'well' && state.grant === 'yes') {
      var g = P.grant || {};
      if (!state.county) return { grantAsk: true };
      if (state.county === 'other') return { grantOther: true };
      var v = GRANT.filter(function (x) { return String(x.id) === String(state.county); })[0];
      if (!v) return { grantAsk: true };
      return {
        main: { key: 'grant', name: 'Well Grant Water Test, ' + v.county, tests: 'Technician sampling', price: v.price, id: v.id, url: g.url + '?variant=' + v.id, img: g.img },
        why: 'Councils only accept a grant sample taken by a technician from an accredited lab. Fitz Scientific rings you to book a visit in ' + v.county + ', usually within 2 weeks.',
        extras: []
      };
    }
    if (state.supply === 'well' && !state.grant) return null;

    var base = state.supply === 'mains' ? (has('lead') ? 'plus' : 'check') : 'plus';
    var baseWhy = base === 'check' ? WHY.check : (state.supply === 'well' ? WHY.plus_well : (state.supply === 'group' ? WHY.plus_group : WHY.plus_lead));
    var S = [];
    Object.keys(CONCERN_KEY).forEach(function (c) { if (has(c) && !(c === 'thm' && state.supply === 'well')) S.push(CONCERN_KEY[c]); });
    var main, why, extras = [];

    if (has('audit')) {
      main = 'audit'; why = WHY.audit;
      S.forEach(function (k) { if (['pesticides', 'thm', 'bacteria'].indexOf(k) < 0) extras.push({ key: k, on: true }); });
    } else if (state.concerns.length === 0 || has('none') || has('lead') || S.length > 1) {
      main = base; why = baseWhy;
      S.forEach(function (k) { if (k !== 'bacteria') extras.push({ key: k, on: true }); });
    } else if (S.length === 1) {
      main = S[0]; why = WHY[S[0]];
      if (['legionella', 'bordbia'].indexOf(main) < 0) extras.push({ key: base, on: false });
    } else {
      main = base; why = baseWhy;
    }
    var m = P[main] || {};
    return {
      main: { key: main, name: m.name, tests: m.tests, price: m.price, id: m.id, url: m.url, img: m.img },
      why: why,
      extras: extras.map(function (e) { var p = P[e.key] || {}; return { key: e.key, name: p.name, price: p.price, id: p.id, url: p.url, on: e.on }; })
        .filter(function (e) { return e.id; })
    };
  }

  function total() {
    if (!current || !current.main) return 0;
    var t = current.main.price;
    current.extras.forEach(function (e) { if (e.on) t += e.price; });
    return t;
  }

  function render() {
    var r = pick();
    current = r && r.main ? r : null;
    var h = '';
    if (!r) {
      h = '<p class="wt-k wt-k--green">Your test</p><h2 class="wt-h">' + (state.supply === 'well' ? 'Is it for the well grant?' : 'Start with where your water comes from') + '</h2>' +
        '<p class="wt-why">' + (state.supply === 'well' ? 'The grant needs a sample taken by a lab technician, so it\'s a different test. Answer on the left.' : 'Two or three taps and we\'ll point you to the right test, with the price. Every test is analysed by Fitz Scientific in Drogheda.') + '</p>';
    } else if (r.grantAsk) {
      var g = P.grant || {};
      var lo = GRANT.reduce(function (a, x) { return Math.min(a, x.price); }, Infinity);
      h = '<p class="wt-k wt-k--green">Your test</p><h2 class="wt-h">The Well Grant Water Test</h2>' +
        '<p class="wt-why">Councils only accept a grant sample taken by a technician from an accredited lab. Pick your county for the price. Fitz Scientific covers 15 council areas, from ' + euro(lo) + '.</p>' +
        '<div class="wt-actions"><a class="btn btn--ghost" href="#grant">See every county\'s price</a></div>';
    } else if (r.grantOther) {
      h = '<p class="wt-k wt-k--green">Your test</p><h2 class="wt-h">Ring us about your county</h2>' +
        '<p class="wt-why">Fitz Scientific\'s technicians cover 15 council areas and yours isn\'t one of them yet. Ring <a href="tel:015546266">01 554 6266</a> and we\'ll point you in the right direction.</p>' +
        '<p class="wt-alt">Not applying for the grant after all? <a href="#" data-wt-nogrant>See the home test kits</a></p>';
    } else {
      var m = r.main;
      h = '<p class="wt-k wt-k--green">Your test</p><h2 class="wt-h">' + esc(m.name) + '</h2>' +
        '<p class="wt-why">' + esc(r.why) + '</p>' +
        '<div class="wt-pick">' + (m.img ? '<img src="' + esc(m.img) + '" alt="" width="84" height="84">' : '') +
        '<div><b>' + esc(m.tests) + '</b><span>Analysed by Fitz Scientific</span></div><em>' + euro(m.price) + '</em></div>';
      if (r.extras.length) {
        h += '<p class="wt-k">' + (r.extras.some(function (e) { return e.on; }) ? 'Also for what you ticked' : 'Want the full picture?') + '</p><ul class="wt-extras">';
        r.extras.forEach(function (e, i) {
          h += '<li><label><input type="checkbox" data-wt-extra="' + i + '"' + (e.on ? ' checked' : '') + '><span>' + esc(e.name) + '<small>' + esc(EXTRA_NOTE[e.key] || '') + '</small></span><b>' + euro(e.price) + '</b></label></li>';
        });
        h += '</ul>';
      }
      h += '<div class="wt-total"><span>Total, incl. VAT</span><b id="wt-total">' + euro(total()) + '</b></div>' +
        '<div class="wt-actions"><button type="button" class="btn btn--green" data-wt-add>Add to cart</button>' +
        '<a class="link" href="' + esc(m.url) + '">What\'s in the ' + esc(m.name.replace(/, .*$/, '')) + '</a></div>' +
        '<p class="wt-credit-sm">' + TICK + '<span>The test fee comes off your install if we fit treatment within 90 days</span></p>' +
        '<p class="wt-err" id="wt-err" hidden>Couldn\'t add that to the cart. <a href="' + esc(m.url) + '">Open the test page</a> instead.</p>';
    }
    out.innerHTML = h;
    bar();
  }

  function bar() {
    var b = document.getElementById('wt-bar');
    if (!b) return;
    if (!current) { b.hidden = true; return; }
    document.getElementById('wt-bar-name').textContent = current.main.name;
    document.getElementById('wt-bar-price').textContent = euro(total()) + ' incl. VAT';
    b.hidden = !barWanted;
  }
  var barWanted = false;
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      var e = en[0];
      barWanted = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar();
    }).observe(out);
  }

  function addToCart(btn) {
    if (!current) return;
    var items = [{ id: current.main.id, quantity: 1 }];
    current.extras.forEach(function (e) { if (e.on) items.push({ id: e.id, quantity: 1 }); });
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('cart'); window.location.href = '/cart'; })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = 'Add to cart'; }
        var err = document.getElementById('wt-err'); if (err) err.hidden = false;
      });
  }

  function setChip(group, v) {
    root.querySelectorAll('[data-wt-group="' + group + '"] .chip').forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-v') === v ? 'true' : 'false'); });
  }
  function syncConcernChips() {
    root.querySelectorAll('[data-wt-group="concerns"] .chip').forEach(function (c) {
      c.setAttribute('aria-pressed', has(c.getAttribute('data-v')) ? 'true' : 'false');
      c.hidden = c.getAttribute('data-not') === state.supply;
    });
  }
  function layout() {
    show('well', state.supply === 'well');
    show('grant', state.supply === 'well' && state.grant === 'yes');
    show('concerns', !!state.supply && !(state.supply === 'well' && state.grant !== 'no'));
    if (state.supply === 'well' && state.concerns.indexOf('thm') > -1) state.concerns.splice(state.concerns.indexOf('thm'), 1);
    syncConcernChips();
    render();
  }

  root.addEventListener('click', function (ev) {
    var chip = ev.target.closest('[data-wt-group] .chip');
    if (chip) {
      var g = chip.parentElement.getAttribute('data-wt-group'), v = chip.getAttribute('data-v');
      if (g === 'concerns') {
        var i = state.concerns.indexOf(v);
        if (i > -1) state.concerns.splice(i, 1);
        else {
          if (v === 'none') state.concerns = [];
          else { var n = state.concerns.indexOf('none'); if (n > -1) state.concerns.splice(n, 1); }
          state.concerns.push(v);
        }
      } else {
        state[g] = v; setChip(g, v);
        if (g === 'supply' && v !== 'well') { state.grant = ''; setChip('grant', ''); }
      }
      layout();
      return;
    }
    if (ev.target.closest('[data-wt-add]')) { addToCart(ev.target.closest('[data-wt-add]')); return; }
    if (ev.target.closest('#wt-bar-add')) { addToCart(ev.target.closest('#wt-bar-add')); return; }
    if (ev.target.closest('[data-wt-nogrant]')) {
      ev.preventDefault(); state.grant = 'no'; setChip('grant', 'no'); layout();
    }
  });
  root.addEventListener('change', function (ev) {
    if (ev.target.id === 'wt-county') { state.county = ev.target.value; render(); return; }
    var x = ev.target.getAttribute && ev.target.getAttribute('data-wt-extra');
    if (x !== null && x !== undefined && current) {
      current.extras[+x].on = ev.target.checked;
      var t = document.getElementById('wt-total'); if (t) t.textContent = euro(total());
      bar();
    }
  });

  // deep link
  try {
    var q = new URLSearchParams(window.location.search);
    var s = q.get('supply'), gr = q.get('grant'), c = q.get('county');
    if (s && /^(mains|well|group)$/.test(s)) { state.supply = s; setChip('supply', s); }
    if (gr && /^(yes|no)$/.test(gr) && state.supply === 'well') { state.grant = gr; setChip('grant', gr); }
    if (c && state.grant === 'yes') {
      var hit = GRANT.filter(function (x) { return x.county.toLowerCase() === c.toLowerCase().replace(/-/g, ' '); })[0];
      state.county = hit ? String(hit.id) : 'other';
      var sel = document.getElementById('wt-county'); if (sel) sel.value = state.county;
    }
    if (s) layout();
  } catch (e) {}
})();
